module.exports = __webpack_public_path__ + "img/inserter-platform.c2f0cf76.png";